import React, { useContext } from "react";
import classNames from "classnames";
import Link from "next/link";
import Styles from "./JoinOurFam.module.scss";
import A from "@vahak/core/dist/components/app-anchor/A";
import { AppContext } from "@vahak/core/dist/app-context";

import ArrowRightBlack from "@vahak/core/dist/icons/ArrowRightBlack.svg";
import AppImg from "components/utils/AppImg";
interface JoinOurFamProps {
    isMobile: boolean;
}
const JoinOurFam = ({ isMobile }: JoinOurFamProps) => {
    return (
        <section className={Styles.joinOurFamSection}>
            <div className={Styles.ourFamBGImg}>
                <AppImg src={"join-our-fam.JPG"} layout="fill" objectPosition="center" objectFit="cover" />
            </div>
            <div className={classNames("container", Styles.textBox)}>
                <h3>Do you want to tag along?</h3>
                <p>We are on a mission to empower small and medium size logistics businesses in India to dream big.</p>
                <A href={`/careers`} className={Styles.joinFam}>
                    Join Our Fam{" "}
                    <ArrowRightBlack
                        style={{
                            width: isMobile ? "12px" : "16px",
                            height: isMobile ? "12px" : "16px",
                            position: "relative",
                            top: "0",
                            right: "-5px"
                        }}
                    />
                </A>
            </div>
        </section>
    );
};

export default JoinOurFam;
